import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

import { toAppointmentSeriesLink } from '../api/series.transform'

import type { SeriesSelection } from './seriesSelectionStore'

// Own classes, so clearing a Series selection never touches the staff-focus dim.
export const SERIES_CARD_CLASSES = {
  selected: 'schedule-event--series-selected',
  sibling: 'schedule-event--series-sibling',
  dim: 'schedule-event--series-dim',
} as const

const ALL_CLASSES = Object.values(SERIES_CARD_CLASSES)

const classFor = (
  event: Pick<IPatientSchedule, 'id' | 'series'>,
  selection: SeriesSelection,
): string => {
  if (Number(event.id) === selection.appointmentId) return SERIES_CARD_CLASSES.selected
  const link = toAppointmentSeriesLink(event.series)
  return link?.id === selection.seriesId ? SERIES_CARD_CLASSES.sibling : SERIES_CARD_CLASSES.dim
}

export const applySeriesSelection = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'id' | 'series'>,
  selection: SeriesSelection | null,
): void => {
  const wanted = selection ? classFor(event, selection) : null
  ALL_CLASSES.forEach((name) => element.classList.toggle(name, name === wanted))
}
